<script>
import { compile, h } from 'vue';
import { mapWritableState } from "pinia";
import { library } from "@common/library/library";
import { controlStore, createStoreIndex, controlTypes } from "@common/control/controlStore";
import { errorHandler } from "@common/errorHandler/errorHandler";

const commonControlProps = ['value', 'display', 'cssClass', 'required', 'label', 'inlineLabel', 'type', 'recordId', 'index', 'placeholder', 'disabled'];

const locals = {
    isRecordStoreSource(iSource) {
        if (!Array.isArray(iSource)) return false;
        let sConfig = iSource[0];
        return typeof sConfig === 'object'
            && Array.isArray(sConfig.source)
            && sConfig.source[0].indexOf('configStore') !== 0
            && sConfig.source[0].indexOf('userStore') !== 0
            && sConfig.source[0].indexOf('componentStore') !== 0;
    }
};
let controlComponent = {
    name: 'control',
    data() {
        return {
            configSourceRan: false,
            localAttrs: false,
            loadingOptions: true,
            recordStore: false,
            updatedTimeout: false
        };
    },
    props: {
        name: {
            type: String,
            required: true
        },
        propConfig: {},
        type: {},
        index: {},
        valuesMap: {
            type: Object
        },
        asField: {},
        componentId: {
            type: String
        },
        recordId: {},
        cssClass: {
            type: String
        },
        required: {},
        label: {
            type: String
        },
        inlineLabel: {},
        items: {},
        value: {},
        placeholder: {
            type: String
        },
        disabled: {},
        display: {},
        globalStoreId: {
            type: String
        }
    },
    computed: {
        cId() {
            // templates in popup have no component
            return this.component ? this.component.cId : null;
        },
        cType() {
            // templates in popup have no component
            return this.component ? this.component.cType : null;
        },
        component() {
            let component = null;
            let parent = this.$parent;
            // @todo refactor to while
            for (let i = 0; i < 30; i++) { // NOSONAR
                if (!parent) break;
                if (parent.fromDynamicTemplate) {
                    component = parent.component || parent;
                    break;
                }
                else if (parent.isPopupTemplate && parent.component) {
                    component = parent.component;
                    break;
                }
                else if (parent.cType === 'tabList' && parent.config.useVueSlot) {
                    // Do nothing, let it continue to get parent component of tabList
                }
                else if (parent.storeId && parent.tmpStoreId) {
                    component = parent;
                    break;
                }
                parent = parent.$parent;
            }
            return component;
        },
        dataTestId() {
            let dataTestId = null;
            let parent = this.$parent;
            // @todo refactor to while
            for (let i = 0; i < 10; i++) { // NOSONAR
                if (!parent) break;
                if (parent && parent.dataTestId) {
                    dataTestId = parent.dataTestId;
                    break;
                }
                parent = parent.$parent;
            }
            return dataTestId + '_' + this.name;
        },
        recordStoreItems() {
            // Handle datasource control (new config method)
            let itemsSource = this.config.itemsSource;
            if (!locals.isRecordStoreSource(itemsSource)) return false;
            itemsSource = itemsSource[0]; // only use the first source for now
            if (typeof itemsSource !== 'object') return false;
            let items = [];
            // load recordStore dynamically, so it's not required for all controls
            if (!this.recordStore) {
                this.recordStore = true;
                import('@common/recordStore')
                    .then((module) => {
                        this.recordStore = module.recordStore();
                    })
                    .catch((result) => {
                        errorHandler.log(result);
                    });
            }
            if (typeof this.recordStore !== 'object') return items;
            let subscription = this.recordStore.subscribe(itemsSource);
            items = this.recordStore.getSubscription(subscription.key);
            return items;
        }
    },
    watch: {
        // Additional watchers are added for commonControlProps in the mounted lifecycle hook
    },
    render() {
        const notRendered = {
            template: '<div style="display: none;"> Control was not rendered ' + this.name + '</div>'
        };
        let config = this.config;
        if (!config) { // If no existing config try to add
            if (this.propConfig) config = this.propConfig; // set config for controls using propConfig
            else { // set config for controls using initOnRender by getting from component controls
                let controlName = this.name.split('__')[0];
                controlName = controlName.replace('_CtrlDrawAsLabel', '').replace('_CtrlDrawAsField', '');
                config = this.propConfig || false;
                if (!config && this.component && this.component.controlConfigs) {
                    config = library.cloneObj(this.component.controlConfigs[controlName]);
                }
                if (config && this.name.indexOf('_CtrlDrawAsLabel') !== -1) {
                    config.type = 'label';
                }
                if (config && this.name.indexOf('_CtrlDrawAsField') !== -1) {
                    config.hideLabel = true;
                }
            }
            if (config) {
                config.name = this.name;
                if (this.name.indexOf('_CtrlDrawAsField') !== -1 || this.name.indexOf('_CtrlDrawAsLabel') !== -1) {
                    let controlName = this.name.split('__')[0];
                    controlName = controlName.replace('_CtrlDrawAsLabel', '').replace('_CtrlDrawAsField', '');
                    config.name = controlName;
                    config.id = controlName;
                    config.ref = controlName;
                }
                config.itemIndexArray = this.itemIndexArray;
                for (let i in this.$attrs) {
                    // properties can be passed through the attributes
                    if (i.indexOf('on') === 0 && i.indexOf(':') === -1 && typeof config[i] === 'undefined') {
                        config[i] = this.$attrs[i];
                    }
                }
                if (this.$attrs['config']) {
                    for (let i in this.$attrs['config']) {
                        if (typeof config[i] === 'undefined') {
                            config[i] = this.$attrs['config'][i];
                        }
                    }
                }
                // Temporarily use non-stored config as this.config
                config.value ??= this.value;
                this.config = config;
                controlStore().addControl(config, this.component, this.controlStoreIndex);
            }
        } else {
            if (this.component && this.component.controls) {
                this.component.controls[config.name] = this.config;
            }
            for (let i in this.$attrs) {
                // properties can be passed through the attributes
                if (i.indexOf('on') === 0 && i.indexOf(':') === -1 && typeof this.config[i] === 'undefined') {
                    this.config[i] = this.$attrs[i];
                }
                if (this.$attrs['config']) {
                    for (let i in this.$attrs['config']) {
                        if (typeof config[i] === 'undefined' || (i === 'fields' && typeof this.$attrs['config'][i] !== 'undefined')) {
                            config[i] = this.$attrs['config'][i];
                        }
                    }
                }
            }
        }
        if (!config) return h(notRendered);
        let type = config.type && config.type.toLowerCase();
        let removeEjsComponents = function (component) {
            for (let i in component.components) {
                if (i === 'length') continue;
                if (i.indexOf('ejs') !== -1) {
                    delete component.components[i];
                }
            }
        };
        if (type && controlTypes[type]) {
            let component = controlTypes[type];
            if (typeof IS_JEST !== 'undefined') {
                removeEjsComponents(component);
                component.render = function () {
                    return h(compile("<div v-bind='config' :data-test-id='dataTestId'></div>")(this));
                };
            }
            return h(component);
        }
        return h(notRendered);
    },
    methods: {
        async runGetFieldConfig(useLocalConfigSource) {
            let configSource = this?.config?.configSource;
            if (Array.isArray(configSource)) configSource = configSource[0];
            if (typeof configSource !== 'string' || this.configSourceRan) return;
            this.configStore = configStore;
            // Get the path dynamically from configSource
            //  TODO: library.getRealIndexes doesn't work because it always is 0 ["0", 4]
            let index = this.config?.itemIndexArray?.[1] || 0;
            if (configSource.match(/this./)) { // Parse the path
                let path = configSource.replace('__index__', index);
                path = path.replace('this.', '');
                // Use the path to get the actual control field
                configSource = library.getByPath(this, path);
            }
            if (Array.isArray(configSource)) configSource = configSource[0]; // matches ["vol:::Some_UDF_Group/UDF_Test_1"]
            if (!configSource) return;
            let fieldConfig = await configStore.getFieldConfig(configSource);
            if (!fieldConfig) return;
            this.configSourceRan = true;
            if (this.config?.fieldId !== fieldConfig?.fieldId) this.config.value = '';
            // Customizer will replace the config data with the fieldConfig, rather than merging it
            // let customizer = function (obj, src) {
            //     return src;
            // };
            // Auto generate name to match code ID
            if (!this.config.name && fieldConfig.fieldId && fieldConfig.fieldId.indexOf(':::') !== -1) {
                fieldConfig.name = fieldConfig.fieldId.split(':::')[1];
            }
            // Merge configs Note: Local configs (in the component) take precedence over UDF settings
            let customizer = (objVal, srcVal) => (!srcVal && typeof srcVal !== 'boolean' ? objVal : srcVal);
            this.config = useLocalConfigSource
                ? library.mergeWith(fieldConfig, this.config, customizer)
                : library.mergeObj(this.config, fieldConfig);
        },
        async resetItems() {
            this.resetingItems = true;
            await this.setItems(true);
            this.resetingItems = false;
        },
        async setItems(force) {
            // let itemsSource = control.getProp(this.name, 'itemsSource', this.cStoreId);
            if (!this.config || (this.resetingItems && !force)) return;
            let itemsSource = this.config.itemsSource;
            if (Array.isArray(itemsSource)) itemsSource = itemsSource[0] ? itemsSource[0] : '';
            if (!itemsSource) {
                this.loadingOptions = true;
                this.$nextTick(() => {
                    this.config.items = this.items || this.config.items || this.config.options;
                    this.loadingOptions = false;
                });
                return;
            }
            // Handle datasource control that uses recordStore separately (new config method)
            if (locals.isRecordStoreSource(itemsSource)) {
                // items come from computed recordStoreItems
                // Reset the syncfusion dropdown options
                this.loadingOptions = true;
                this.$nextTick(() => {
                    this.loadingOptions = false;
                });
                return;
            }
            let tmpItems = [];
            if (typeof itemsSource === 'object' && Array.isArray(itemsSource.source)) itemsSource = itemsSource.source[0];
            itemsSource = library.getRealIndexes(itemsSource, this, this.itemIndexArray);
            if (itemsSource.indexOf('this.') === 0) {
                // get from the component data
                // TODO do we still need to get items from parent component of settingsEditor
                tmpItems = library.cloneObj(library.getByPath(this.component, itemsSource.replace('this.', '')));
            } else {
                if (itemsSource.indexOf('(') !== -1) {
                    let tmpParams = library.getFunctionParams(itemsSource);
                    for (let tmpI in tmpParams) {
                        let tmpParamValue = tmpParams[tmpI];
                        if (tmpParamValue.indexOf('this.') === 0) {
                            let paramString = tmpParamValue.replace('this.', '');
                            tmpParamValue = library.cloneObj(library.getByPath(this, paramString));
                            if (!tmpParamValue) {
                                tmpParamValue = false;
                            } else if (typeof tmpParamValue === 'object') { // Leave objects as objects
                                tmpParamValue = JSON.stringify(tmpParamValue);
                            } else { // Leave objects as objects
                                tmpParamValue = '"' + tmpParamValue + '"';
                            }
                            itemsSource = itemsSource.replace(tmpParams[tmpI], tmpParamValue);
                        }
                    }
                    // call the function to get data
                    tmpItems = library.eval(itemsSource);
                    if (typeof tmpItems === 'object' && !Array.isArray(tmpItems) && typeof tmpItems.finally === 'function' && typeof tmpItems.then === 'function') {
                        tmpItems = await tmpItems;
                    }
                } else {
                    // get from the store state
                    if (itemsSource.indexOf('__layoutStoreId__') !== -1) {
                        itemsSource.replace(/__layoutStoreId__/g, this.component.layoutStoreId);
                    }
                    tmpItems = library.cloneObj(library.getByPath(this.$store.state, itemsSource));
                }
            }
            if (!library.isEqualObj(this.config.items, tmpItems)) {
                // Reset the syncfusion dropdown options
                this.loadingOptions = true;
                this.$nextTick(() => {
                    this.config.items = tmpItems;
                    this.loadingOptions = false;
                });
            }
        }
    },
    async mounted() {
        if (this.config?.configSource) {
            const useLocalConfig = !!this.config.prioritizeLocalSourceConfig;
            await this.runGetFieldConfig(useLocalConfig);
        }
        await this.setItems();
        this.loadingOptions = false;
        // Keep these watchers here to prevent premature value changes in controls
        commonControlProps.forEach((prop) => {
            this.$watch(prop, (newValue) => {
                if (typeof newValue === 'undefined') return;
                if (this.config) this.config[prop] = this[prop];
            }, { immediate: true });
        });
    },
    async updated() {
        if (this.config?.configSource) {
            const useLocalConfig = !!this.config.prioritizeLocalSourceConfig;
            await this.runGetFieldConfig(useLocalConfig);
        }
        if (this.updatedTimeout) clearTimeout(this.updatedTimeout);
        this.updatedTimeout = setTimeout(() => {
            this.setItems();
        }, 500);
    },
    unmounted() {
        let fromListItem = this.$parent
            && this.$parent.$parent
            && this.$parent.$parent.config
            && this.$parent.$parent.config.type === 'list';
        let fromDynamicTemplate = this.$parent
            && this.$parent.$parent
            && typeof this.$parent.$parent.fromDynamicTemplate !== 'undefined'
            && this.$parent.$parent.fromDynamicTemplate;
        if ((this && this.config && this.config.removeOnDestroy) || fromListItem || fromDynamicTemplate) {
            if (!this?.config?.doNotRemoveOnDestroy) controlStore().removeControl(this);
        }
    },
    beforeCreate() {
        let parentControlIndex = this.$parent.$parent.controlStoreIndex;
        let itemIndexArray = library.getFromParents(this.$parent, { itemIndexArray: '!!' }, 'itemIndexArray') || [];
        let storeId = library.getFromParents(this.$parent, { storeId: '!!' }, 'storeId');
        let storePath = this.globalStoreId
            ? ['global', this.globalStoreId]
            : parentControlIndex || storeId;
        let controlStoreIndex = createStoreIndex(storePath, this.name);
        // Add path props to control
        this.$options.computed = {
            ...this.$options.computed,
            controlStoreIndex() {
                return controlStoreIndex;
            },
            itemIndexArray() {
                if (typeof this.index !== 'undefined') return [...itemIndexArray, this.index];
                return itemIndexArray;
            },
            ...mapWritableState(controlStore, {
                'config': controlStoreIndex
            })
        };
    }
};

export default controlComponent;
export { controlComponent };
</script>

<style>
.input-info {
    margin-top: 5px;
    color: #2973b7;
}
.loading-message {
    color: black;
    font-size: 12px;
}
</style>
